<template>
  <div v-if="$store.state.isUserLoggedIn">
    <v-bottom-navigation fixed>
      <v-btn value="dashboard" :to="{ path: '/' }">
        <span>Dashboard</span>
        <v-icon>mdi-view-dashboard</v-icon>
      </v-btn>

      <v-btn value="members" :to="{ path: '/consortia' }">
        <span>Consortia</span>
        <v-icon>mdi-account-group</v-icon>
      </v-btn>

      <v-btn value="committees" :to="{ path: '/companies' }">
        <span>Companies</span>
        <v-icon>mdi-card-account-details</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {}
</script>
